import React from "react";
import { TeamMember } from "./TeamsTab";

type ImageDisplayProps = {
  profile: TeamMember;
  className?: string;
  imageClassName?: string;
  onClick?: (member: TeamMember) => void;
};

const ImageDisplay: React.FC<ImageDisplayProps> = ({
  profile,
  className,
  imageClassName,
  onClick,
}) => {
  return (
    <div
      className={`group relative w-full aspect-square overflow-hidden rounded-md cursor-pointer ${className ?? ""}`}
      onClick={() => onClick(profile)}
    >
      <img
        src={profile.profileSrc}
        alt={`${profile.name} profile photo`}
        className={`h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-105 ${
          imageClassName ?? ""
        }`}
      />

      <div className="pointer-events-none absolute inset-0 bg-black/0 transition-colors duration-300 group-hover:bg-black/40" />

      <div className="pointer-events-none absolute inset-x-0 bottom-0 translate-y-full transition-transform duration-300 ease-out group-hover:translate-y-0">
        <div className="rounded-md bg-black/70 p-3 text-white shadow-lg backdrop-blur-sm">
          <p className="text-sm font-semibold leading-tight">{profile.name}</p>
          <p className="text-xs opacity-90">{profile.title}</p>
        </div>
      </div>
    </div>
  );
};

export default ImageDisplay;
